import React from "react";

const CryptoHuntTimer = ({ time }) => {
  return (
    <div
      style={{ boxShadow: "0 0 10px rgba(255,255,255,0.7) inset" }}
      className="flex rounded-full sm:px-20 px-10 py-5 border-2 border-primary  bg-black font-bold font-redHat uppercase items-center gap-x-6"
    >
      <span className="">Time Left</span>
      <h1 className=" text-[#200052] sm:text-[32px] text-xl">{time} Sec</h1>
    </div>
  );
};

export default CryptoHuntTimer;
